<template>
  <div class="printReportPage">
    <div class="leftContent" v-if="!isAiCenter">
      <div class="leftTitle">打印报告</div>
      <div class="reportCard">
        <div>检查时间：{{printReport.checkTime}}</div>
        <div>检查项目：{{printReport.deviceCategoryName}}</div>
        <div class="checkBody">
          <div>检查部位：</div>
          <div v-for="(body, bIndex) in printReport.bodyItems" :key="bIndex">
            <div>{{body}}</div>
          </div>
        </div>
        <div>检查医院：{{printReport.imageCenterName}}</div>
      </div>
    </div>
    <div class="rightContent" :class="{noHaveLeft: isAiCenter}">
      <Tabs tabPosition="top" v-if="tabPans.length > 0">
        <div slot="tabBarExtraContent" style="margin-right: 135px;">
          <Button style="margin-top:5px;" v-print="'#printContent'" v-if="!isAiCenter">打印</Button>
          <Button style="margin:5px 20px 0 10px;" @click="goBack">返回</Button>
        </div>
        <TabPane v-for="(tabPan, index) in tabPans" :key="++index" :tab="tabPan.title">
          <div class="reportWraper" v-if="tabPan.title==='常规报告'" :class="{noCommonReport: tabPan.report.status !== 100}">
            <div class="reportContent" v-if="tabPan.report.status == 100">
              <PrintTemplate :report="tabPan.report" id="printContent" :showType="'print'"/>
            </div>
            <List v-if="tabPan.report.status !== 100">
              <ListItem v-for="(file, kIndex) in []" :key="kIndex"></ListItem>
            </List>
          </div>
          <div class="autoReport" v-if="tabPan.title !=='常规报告'">
            <List class="listWrap">
              <ListItem v-for="(file, index) in tabPan.report ? tabPan.report : []" :key="index">
                <div v-if="file.status == 100" class="fileList" >
                  <span>{{file.file_name?file.file_name:''}}</span>
                  <a style="margin-left: 10px;" @click="downLoadOrPreview(file)">下载</a>
                </div>
              </ListItem>
            </List>
          </div>
        </TabPane>
      </Tabs>
      <List v-if="tabPans.length <= 0">
        <ListItem v-for="(temp, tIndex) in []" :key="tIndex"></ListItem>
      </List>
    </div>
  </div>
</template>
<script>
import { Tabs, List, Button } from 'ant-design-vue'
import PrintTemplate from '../../components/PrintTemplate'
import { getPrintReport } from '../../api/report'
import  { getParamFromRoute } from '../../libs/utils'
import { groupBy, sortBy, findLast } from 'lodash'
import { getImageBase64Code, downLoadFile } from '../../api/user'
import { mapState } from 'vuex'
import { getAiCheckImageCenterId } from '../../config'
export default {
  components: {
    Tabs,
    TabPane: Tabs.TabPane,
    PrintTemplate,
    List,
    ListItem: List.Item,
    Button
  },
  data () {
    return {
      printReport: {},
      tabPans: [],
      downLoadTimer: null,
      reportId: ''
    }
  },
  async mounted () {
    let routeParams = getParamFromRoute(this.$route)
    if (routeParams.reportId) {
      this.reportId = routeParams.reportId
      await this.initData(routeParams.reportId)
    }
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId
    }),
    isAiCenter() {
      if (this.currentCenterId == getAiCheckImageCenterId()) return true
      return false
    }
  },
  methods: {
    async initData (id) {
      let data = await getPrintReport({reportId: id})
      if (!data) return false
      this.printReport = data
      if (data.reportDoctorInfo) {
        try {
          let reportDoctor = JSON.parse(data.reportDoctorInfo)
          if (reportDoctor && reportDoctor.write_doctor && reportDoctor.write_doctor.signature_image_url) {
            reportDoctor.write_doctor.signature_image_url = await getImageBase64Code(reportDoctor.write_doctor.signature_image_url + `?v=${new Date().valueOf()}`)
          }
          if (reportDoctor && reportDoctor.review_doctor && reportDoctor.review_doctor.signature_image_url) {
            reportDoctor.review_doctor.signature_image_url = await getImageBase64Code(reportDoctor.review_doctor.signature_image_url + `?v=${new Date().valueOf()}`)
          }
          this.printReport.reportDoctorInfo = reportDoctor
        } catch (error) {
          console.log('解析报告医生姓名错误', error)
        }
      }
      this.createTabPanes(data)
    },
    createTabPanes (history) {
      if (!history || !history.orderCheckReportList || history.orderCheckReportList.length < 1) return false
      history.orderCheckReportList.forEach(element => {
        if (!element.base_element_name) element.base_element_name = '常规报告'
      })
      let cate = groupBy(history.orderCheckReportList, 'base_element_name')
      let tabPans = []
      for (let k in cate) {
        let cateItem = cate[k]
        let cateObj = {title: k}
        if (k === '常规报告') {
          cateObj.report = findLast(cateItem,{status: 100}) || {}
          cateObj.report.reportDoctorInfo = this.printReport.reportDoctorInfo
          cateObj.sortKey = 1
        } else {
          let report = []
          for (let i = 0; i < cateItem.length; i++) {
            let item = cateItem[i]
            if (!item.report_file_url || item.status!== 100) continue
            let arrFileUrl = JSON.parse(item.report_file_url)
            for (let j = 0; j<arrFileUrl.length; j++) {
              let fileItem = arrFileUrl[j]
              fileItem.status = item.status
            }
            report = report.concat(arrFileUrl)
          }
          cateObj.report = report
          cateObj.sortKey = 2
        }
        tabPans.push(cateObj)
      }
      tabPans = sortBy(tabPans, 'sortKey')
      // 如果是AI影像中心就不显示常规报告
      if (this.isAiCenter) tabPans.splice(0, 1)
      this.tabPans = tabPans
    },
    downLoadOrPreview (file) {
      if (!file.file_url || this.downLoadTimer) return false
      this.downLoadTimer = setTimeout(() => {
        downLoadFile(file.file_url, file.file_name)
        clearTimeout(this.downLoadTimer)
        this.downLoadTimer = null
      }, 100)
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>
<style lang="less">
@import '../../style/common/mixin.less';
@import '../../style/common/variable.less';
// 隐藏头部
.printReportPage{
  width: 100%;
  height: 100%;
  overflow: hidden;
  .leftContent{
    width: 20%;
    height: 100%;
    float: left;
    border-right: 1px solid @divideLineColor;
    border-top: 1px solid @divideLineColor;
    background-color: @baseColor;
    overflow-y: auto;
    .leftTitle{
      line-height: 42px;
      padding-left:20px;
      font-weight: 500;
      border-bottom: 1px solid @divideLineColor;
    }
    .reportCard{
      padding: 20px;
      color:#333;
      .watchImage{
        a{
          color:#333;
          margin-right: 15px;
        }
      }
      border-bottom: 1px solid @divideLineColor;
    }
    .reprotActive{
      background-color:@primaryColor;
      color:@baseColor;
      .watchImage{
        a{
          color:@baseColor;
        }
      }
    }
  }
  .rightContent{
    margin-left: 20%;
    height: 100%;
    .ant-tabs{
      height: 100%;
      position: relative;
      .ant-tabs-nav-container{
        border-top:1px solid @divideLineColor;
      }
    }
    .ant-tabs-bar{
      position: relative;
      z-index: 10;
      height: 46px;
      background-color:  @baseColor;
    }
    .ant-tabs-content{
      position: absolute;
      top: 60px;
      height: 100%;
      .ant-tabs-tabpane{
        position: relative;
        .reportWraper{
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top:0;
          bottom: 50px;
          height: 100%;
          overflow-y: auto;
          .reportContent{
            width: calc(21cm + 60px);
            background: @baseColor;
            margin-bottom: 100px;
          }
        }
        .noCommonReport{
          width: 100%;
          height: auto;
          bottom: unset;
          background-color: @baseColor;
        }
        .autoReport{
          padding-left: 20px; 
          background-color: #fff;
          .fileList{
            cursor: pointer;
          }
        }
      }
    }
  }
  @media all and (max-width: 1090px) {
    .leftContent{
      width: 30%;
      height: 100%;
      float: left;
      border-right: 1px solid @divideLineColor;
      border-top: 1px solid @divideLineColor;
      background-color: @baseColor;
      overflow-y: auto;
    }
    .rightContent{
      margin-left: 30%;
      height: 100%;
      .ant-tabs-content{
        position: absolute;
        top: 60px;
        height: 100%;
        .ant-tabs-tabpane{
          position: relative;
          .reportWraper{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top:0;
            bottom: 50px;
            height: 100%;
            overflow-y: auto;
            .reportContent{
              width: calc(15cm + 100px);
              background: @baseColor;
              margin-bottom: 100px;
            }
          }
        }
      }
    }
  }
  .noHaveLeft{
    margin-left: 0;    
  }
}
</style>